import type { NotificationContent } from "../../../components/notifications/notification-content.types"
import { statusHistoryHref } from "../../StatusAutomation/helpers/status-automation"
import type { Notification } from "../types/notification.types"
import { legacyContent } from "./legacyContent"

const AUTOMATION_ACTOR = "Automation"

/** Where a notice about a status rule's move opens: the record, history up. */
export function automationHref(notification?: Notification | null): string | null {
  const data = notification?.data
  if (!data?.automation) return null
  // The data names the record; `target.type` cannot, since a lead's target is
  // the same concrete model as a project's.
  if (data.project_id) return statusHistoryHref("project", String(data.project_id))
  if (data.lead_id) return statusHistoryHref("lead", String(data.lead_id))
  return null
}

/**
 * The content block a row renders. The server's block (or the legacy one)
 * says nothing about a move a status rule made, so such a row is credited to
 * Automation and opens where its Undo is.
 */
export function notificationContent(notification?: Notification | null): NotificationContent {
  const content = notification?.content ?? legacyContent(notification)
  const href = automationHref(notification)
  if (!href) return content
  return {
    ...content,
    actor: content.actor ?? {
      name: notification?.actor?.name || AUTOMATION_ACTOR,
      relation: "automation"
    },
    action: { key: "review_status_history", target: { kind: "legacy_href", url: href } }
  }
}
